import {
    GetListApiV1NotificationsFeedUserEventListGetQueryParams,
    useGetListApiV1NotificationsFeedUserEventListGetInfinite,
} from '../gen/base'

const DEFAULT_LIMIT = 10

export const useInfiniteNotificationsFeedUserEventListQuery = (
    params: GetListApiV1NotificationsFeedUserEventListGetQueryParams,
) => {
    const limit = params.limit ?? DEFAULT_LIMIT

    return useGetListApiV1NotificationsFeedUserEventListGetInfinite(
        { ...params, limit },
        {},
        {
            query: {
                getNextPageParam: (lastPage, allPages) =>
                    lastPage.offset + limit <= lastPage.total_count
                        ? allPages.length * limit
                        : null,
                initialPageParam: 0,
            },
        },
    )
}
